<template>
  <div
      id="dragButton"
      class="drag-wrapper"
      :style="`left: ${left}px; top:${top}px;`"
      @touchstart="touchstart"
      @touchmove.stop.prevent="touchmove"
      @touchend="touchend"
      :class="{transition: isDock && !isMove }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'DragButton',
  props: {
    isDock: {
      type: Boolean,
      default: true
    },
    existTabBar: {
      type: Boolean,
      default: true
    },
    topHeight: {
      type: Number,
      default: 400
    }
  },
  data () {
    return {
      top: 0,
      left: 0,
      width: 0,
      height: 0,
      offsetWidth: 0,
      offsetHeight: 0,
      windowWidth: 0,
      windowHeight: 0,
      isMove: true,
      edge: 0
    };
  },
  mounted () {
    this.windowWidth = document.getElementsByTagName('html')[0].offsetWidth;
    this.windowHeight = window.outerHeight;

    // if (sys.windowTop) {
    //   this.windowHeight += sys.windowTop;
    // }
    // console.log(sys);

    const dom = document.getElementById('dragButton');
    if (dom) {
      this.width = dom.offsetWidth;
      this.height = dom.offsetHeight;
      this.offsetWidth = dom.offsetWidth / 2;
      this.offsetHeight = dom.offsetHeight / 2;
    }
    this.left = this.windowWidth - this.width - this.edge;
    // this.left = 0;
    // this.top = this.windowHeight - this.height - this.edge;
    this.top = this.topHeight;
  },
  methods: {
    touchstart (e) {
      this.left = e.touches[0].clientX - this.offsetWidth;
      this.top = e.touches[0].clientY - this.offsetHeight;
    },
    touchmove (e) {
      if (e.touches.length !== 1) {
        return false;
      }

      this.isMove = true;

      this.left = e.touches[0].clientX - this.offsetWidth;

      let clientY = e.touches[0].clientY - this.offsetHeight;
      // clientY += this.height;
      const edgeBottom = this.windowHeight - this.height - this.edge;

      if (clientY < this.edge) {
        this.top = this.edge;
      } else if (clientY > edgeBottom) {
        this.top = edgeBottom;
      } else {
        this.top = clientY;
      }
    },
    touchend (e) {
      if (this.isDock) {
        const edgeRight = this.windowWidth - this.width - this.edge;

        if (this.left < this.windowWidth / 2 - this.offsetWidth) {
          this.left = this.edge;
        } else {
          this.left = edgeRight;
        }
      }
      this.isMove = false;
      this.$emit('btnTouchend');
    }
  }
};
</script>

<style lang="scss" scoped>
.drag-wrapper {
  position: fixed;
  z-index: 999999;

  &.transition {
    transition: left .3s ease, top .3s ease;
  }
}
</style>
